export default __webpack_public_path__ + "static/media/audio_42_bebe_llorando.bbabce74.mp3";